import Vue from 'vue'
import Router from 'vue-router'
import routes from 'vue-auto-routing'
import { createRouterLayout } from 'vue-router-layout'
import store from '@/store'

Vue.use(Router)

const RouterLayout = createRouterLayout((layout) => {
  return import('@/layouts/' + layout + '.vue')
})

const rout = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      component: RouterLayout,
      children: routes
    },
    {
      path: '*',
      redirect: { name: 'error-404' }
    }
  ]
})

rout.beforeEach(async (to, from, next) => {
  /*if (
    localStorage.getItem('subdomain') === null ||
    localStorage.getItem('subdomain') === undefined
  ) {
    if (!store.getters['utils/getIsloading']) {
      store.dispatch('utils/actionLoading')
    }
    //await store.dispatch('subdomain/consultSubdomain', location.hostname)
    if (store.getters['utils/getIsloading']) {
      store.dispatch('utils/actionLoading')
    }
  }*/

  if (
    store.getters['session/isAuth'] &&
    !['auth-login', 'auth-forgot', 'submenu-menu', 'error-404'].includes(
      to.name
    )
  ) {
    store.dispatch('utils/actionLoading')
  } else if (store.getters['utils/getIsloading']) {
    store.dispatch('utils/actionLoading')
  }

  //if (store.getters['subdomain/getSubdomainFound']) {
  if (
    !store.getters['session/isAuth'] &&
    !['auth-login', 'auth-forgot'].includes(to.name)
  ) {
    next({ name: 'auth-login' })
  }
  if (store.getters['session/isAuth'] && to.name === 'auth-login') {
    next({ name: 'index' })
  }
  if (
    ![
      'auth-login',
      'auth-forgot',
      'index',
      'settings',
      'overview',
      'submenu-menu',
      'error-404'
    ].includes(to.name) &&
    !store.getters['session/isAdmin'] &&
    (to.meta['permission'] === undefined ||
      !store.getters['session/getPermissions'](to.meta['permission']))
  ) {
    next('/error-404')
  }
  /*} else if (to.name !== 'error-404') {
    next({ name: 'error-404' })
  }*/

  // El complemento de WhatsApp se vende aparte. Se pregunta una vez por empresa
  // y queda guardado; el estado trae de qué empresa es, así que cambiar de
  // empresa lo vuelve a pedir solo, y cerrar sesión lo limpia.
  const empresa = store.getters['company/getCompanyData']
  if (store.getters['session/isAuth'] && empresa) {
    const rutasWhatsapp = ['whatsapp', 'whatsapp-settings', 'whatsapp-upgrade']
    let derecho = store.getters['whatsapp/getEntitlement']

    if (!derecho || derecho.company !== empresa.pk) {
      const consulta = store.dispatch('whatsapp/fetchEntitlement', empresa.pk)
      // Sólo se espera la respuesta cuando la pantalla depende de ella. En el
      // resto se pide sin bloquear: un endpoint lento no puede frenar
      // pantallas que no tienen nada que ver con el módulo.
      if (rutasWhatsapp.includes(to.name)) {
        await consulta
        derecho = store.getters['whatsapp/getEntitlement']
      }
    }

    // Nulo significa "no se sabe", y no saber no es no tener: si la consulta
    // falló se deja pasar y decide el 403 de la API, que el interceptor atiende
    // llevando a la pantalla del complemento. Si acá se tratara como "no lo
    // tiene", un backend caído o un token vencido le ofrecería el complemento a
    // la imprenta que ya lo paga.
    if (derecho && derecho.company === empresa.pk) {
      const destinos = ['whatsapp', 'whatsapp-settings']
      if (!derecho.enabled && destinos.includes(to.name)) {
        return next({ name: 'whatsapp-upgrade' })
      }
      if (derecho.enabled && to.name === 'whatsapp-upgrade') {
        return next({ name: 'whatsapp' })
      }
    }
  }

  next()
})

export default rout
